<template>
  <FoldSection title="Tour description" :expand="true">
    <div class="tour-description">
      <div v-if="tour.descriptionAuthor && tour.descriptionAuthor.photo" class="author-update-info">
        <img
          :data-src="tour.descriptionAuthor.photo"
          class="author-avatar lazyload"
          :alt="tour.descriptionAuthor.name"
        />
        <h4 class="author-name">by {{ tour.descriptionAuthor.name }}</h4>
        <p class="author-update-time">{{ tour.descriptionAuthor.update }}</p>
      </div>
      <div class="description-text" v-html="tour.description"></div>
    </div>
  </FoldSection>
</template>
<script>
import FoldSection from "@/components/containers/FoldSection"

export default {
  name: "TourDescription",
  components: {
    FoldSection
  },
  props: {
    tour: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.tour-description {
  .author-update-info {
    display: grid;
    grid-template-columns: 48px 1fr;
    grid-template-rows: 1fr;
    gap: 8px;
    margin-bottom: 16px;
    margin-top: 32px;
    .author-avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      grid-column: 1;
      grid-row: 1 / 3;
    }
    .author-name {
      font-size: 18px;
      font-weight: 700;
      grid-column: 2;
      color: $blackberry;
      height: 22px;
      grid-row: 1;
      margin-bottom: 0;
    }
    .author-update-time {
      font-size: 16px;
      font-style: italic;
      color: $blackberry;
      grid-column: 2;
      grid-row: 2;
    }
  }
  .description-text {
    &::v-deep {
      h2, h3, h4, h5 {
        font-family: $font-sans-serif !important;
        font-size: 18px;
        color: $woi-red-main;
        font-weight: 700;
      }
      p {
        margin: 0 0 32px;
        letter-spacing: 0 !important;
        line-height: 22px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

@include max-width($tablet - 1) {
  .tour-description {
    margin-bottom: 2rem;
  }
}
</style>